import React from "react";
import "../../../App.css";
const UnderMaintenance = () => {
  return (
    <div className="underMaintainance-container">
      <div className="maintenceInnerContainer alreadyFeed">
        <h2 className="maintenceInnerHeader">Under Maintenance!</h2>
        <div className="maintenceInnerBody">
          <h3>We&rsquo;ll be back soon!</h3>
          <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance
        at the moment !</p>
        </div>
      </div>
    </div>
  );
};

export default UnderMaintenance;
